import style from './wallex-subtext.module.scss'
import { InView } from 'react-intersection-observer';
import animations from '@styles/animations.module.scss'

const WallexSubtext = (props: any) => {
    let { state } = props;
    return (
        <InView triggerOnce={true}>
            {({ inView, ref, entry }) => {
                if (inView) {
                    entry?.target.classList.add(animations.active);
                }
                return (
                    <>
                        <h2 ref={ref} className={`${style.wallex__subtext} ${animations.scroll__animation}`}>
                            {state}
                        </h2>
                    </>
                )
            }}
        </InView>
    )


}

export default WallexSubtext;
